import { CardFooter } from '@cmctechnology/phoenix-stockbroking-web-design';
import styled from 'styled-components';

export const CardFooterWithSmallPaddingTop = styled(CardFooter)`
  padding-top: 2rem;
`;
